import React from "react";

const SortUpIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 11 9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.43103 0L10.1344 8.14655H0.727621L5.43103 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SortUpIcon;
